export type OrderingSeed = { id: string; title: string; first: string; second: string; third: string; fourth: string; fifth: string; }
export type SelectionSeed = { id: string; title: string; a: string; b: string; c: string; d: string; e: string; }
export type GraphSeed = { id: string; title: string; p: string; q: string; r: string; s: string; t: string; }

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = Math.imul(31, hash) + str.charCodeAt(i) | 0;
  return hash;
}

function mulberry32(a: number) {
  return function() {
    let t = a += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
}

export class SeedGenerator {
  private rng: () => number;
  constructor(seedString: string) {
    this.rng = mulberry32(hashString(seedString));
  }
  
  randomInt(min: number, max: number): number {
    return Math.floor(this.rng() * (max - min + 1)) + min;
  }
  
  shuffle<T>(array: T[]): T[] {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = this.randomInt(0, i);
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
}

export function generateOrderingSeed(id: string): OrderingSeed {
  const gen = new SeedGenerator(id);
  const contexts = [
    { title: 'Năm công đoạn sản xuất', items: ['Nhập liệu', 'Gia công', 'Lắp ráp', 'Kiểm thử', 'Đóng gói'] },
    { title: 'Năm môn học trong ngày', items: ['Toán', 'Lý', 'Hóa', 'Văn', 'Anh'] },
    { title: 'Năm trạm xe buýt liên tiếp', items: ['Trạm A', 'Trạm B', 'Trạm C', 'Trạm D', 'Trạm E'] },
    { title: 'Năm ca trực của bác sĩ', items: ['Khám bệnh', 'Phẫu thuật', 'Hội chẩn', 'Nghỉ ngơi', 'Báo cáo'] },
  ];
  const context = contexts[gen.randomInt(0, contexts.length - 1)];
  const items = gen.shuffle(context.items);
  return { id, title: context.title, first: items[0], second: items[1], third: items[2], fourth: items[3], fifth: items[4] };
}

export function generateSelectionSeed(id: string): SelectionSeed {
  const gen = new SeedGenerator(id);
  const contexts = [
    { title: 'Chọn ban nhạc 5 thành viên', items: ['Guitar', 'Bass', 'Trống', 'Vocal', 'Keyboard'] },
    { title: 'Chọn tổ dự án 5 người', items: ['Nam', 'Nữ', 'Sếp', 'Nhân viên', 'Thực tập sinh'] }, // General names
    { title: 'Chọn 5 môn thể thao', items: ['Bơi lội', 'Điền kinh', 'Bóng đá', 'Cầu lông', 'Bóng bàn'] },
  ];
  
  const nameSets = [
    ['Duy', 'Hùng', 'Kiên', 'Long', 'Minh'],
    ['Cúc', 'Đào', 'Hồng', 'Lan', 'Mai'],
    ['Cam', 'Chanh', 'Dưa', 'Mận', 'Táo']
  ];
  
  const context = gen.randomInt(0, 1) === 0 ? { title: 'Chọn 5 thành viên', items: nameSets[gen.randomInt(0, nameSets.length - 1)] } : contexts[gen.randomInt(0, contexts.length - 1)];
  const items = gen.shuffle(context.items);
  return { id, title: context.title, a: items[0], b: items[1], c: items[2], d: items[3], e: items[4] };
}

export function generateGraphSeed(id: string): GraphSeed {
  const gen = new SeedGenerator(id);
  const contexts = [
    { title: 'Mạng lưới 5 máy chủ', items: ['Server A', 'Server B', 'Server C', 'Server D', 'Server E'] },
    { title: 'Hệ thống 5 kho hàng', items: ['Kho 1', 'Kho 2', 'Kho 3', 'Kho 4', 'Kho 5'] },
    { title: '5 trạm viễn thông', items: ['Trạm X', 'Trạm Y', 'Trạm Z', 'Trạm U', 'Trạm V'] },
  ];
  const context = contexts[gen.randomInt(0, contexts.length - 1)];
  const items = gen.shuffle(context.items);
  return { id, title: context.title, p: items[0], q: items[1], r: items[2], s: items[3], t: items[4] };
}
